





















import { i18n } from '@/i18n';
import { defineComponent, ref, watch, getCurrentInstance, computed } from 'vue-demi';
import { switchViewType, getViewType, ViewType, initData, isShowMrchTipsInCache, setSwitchBtnClickTag } from './business';

export default defineComponent({
  name: 'SwitchBtn',
  emits: ['change'],
  props: {
    disable: {
      type: Boolean,
      defaults: false,
    },
  },
  setup(props, context) {
    // 当前展示的类型
    const type = ref<ViewType>(ViewType.couponList);
    // 是否展示tip
    const isShowMchTip = ref(false);


    const instance = getCurrentInstance();
    const name = instance?.proxy.$route.name;
    initData(name || '');
    type.value = getViewType();
    // 判断是否展示tip
    checkTipIfShow();
    notifyViewTypeChanged();

    const biType = computed(() => (type.value === ViewType.couponList ? ViewType.merchantList : ViewType.couponList));

    const ariaSwitchText = computed(() => (type.value === ViewType.couponList ? i18n('按商户领取优惠券') : '优惠券'));

    /**
     * 切换视图展示
     */
    function handleClick() {
      if (props.disable) {
        return;
      }
      type.value = switchViewType();
      checkTipIfShow();
      setSwitchBtnClickTag();
    }

    /**
     * 处理tip展示
     */
    function checkTipIfShow() {
      if (type.value === ViewType.couponList && isShowMrchTipsInCache()) {
        isShowMchTip.value = true;
      } else {
        isShowMchTip.value = false;
      }
    }
    /**
     * 视图类型变化通知
     */
    function notifyViewTypeChanged() {
      context.emit('change', type.value);
    }

    watch(type, () => {
      notifyViewTypeChanged();
    });

    return {
      ViewType,
      type,
      isShowMchTip,
      biType,
      ariaSwitchText,
      handleClick,
    };
  },
});
